import { defineAsyncComponent } from 'vue';

const choseFinanceReportSetting = defineAsyncComponent(() =>
  import('@/views/financeReportSetting/ChoseFinanceReportSetting.vue')
);

const choseOrganizationReportShare = defineAsyncComponent(() =>
  import('@/views/financeReportSetting/ChoseOrganizationReportShare.vue')
);

const financeReportSetting = defineAsyncComponent(() =>
  import('@/views/financeReportSetting/FinanceReportSetting.vue')
);

const financeReportSetting_BCTC04 = defineAsyncComponent(() =>
  import('@/views/financeReportSetting/FinanceReportSetting_BCTC04.vue')
);

const financeReportSetting_BCTC03b = defineAsyncComponent(() =>
  import('@/views/financeReportSetting/FinanceReportSetting_BCTC03b.vue')
);

const summaryReportSetting = defineAsyncComponent(() =>
  import('@/views/financeReportSetting/SummaryReportSetting.vue')
);

const CellReportSetting = defineAsyncComponent(() => import('@/views/utility/reportConfig/CellReportSetting.vue'));

const CellReportSetting_B03b = defineAsyncComponent(() =>
  import('@/views/utility/reportConfig/CellReportSetting_B03b.vue')
);

const MoneyColumnSetting = defineAsyncComponent(() => import('@/views/utility/reportConfig/MoneyColumnSetting.vue'));

const choseLayoutReportSetting = defineAsyncComponent(() =>
  import('@/views/financeReportSetting/ChoseLayoutReportSetting.vue'),
);

const layoutReportPreview = defineAsyncComponent(() => import('@/views/financeReportSetting/LayoutReportPreview.vue'));

export function registerFr(app) {
  app.component('ChoseFinanceReportSetting', choseFinanceReportSetting);
  app.component('ChoseOrganizationReportShare', choseOrganizationReportShare);
  app.component('FinanceReportSetting', financeReportSetting);
  app.component('SummaryReportSetting', summaryReportSetting);
  app.component('FinanceReportSetting_BCTC04', financeReportSetting_BCTC04);
  app.component('FinanceReportSetting_BCTC03b', financeReportSetting_BCTC03b);

  app.component('CellReportSetting', CellReportSetting);
  app.component('MoneyColumnSetting', MoneyColumnSetting);
  app.component('CellReportSetting_B03b', CellReportSetting_B03b);

  app.component('ChoseLayoutReportSetting', choseLayoutReportSetting);
  app.component('LayoutReportPreview', layoutReportPreview);
}
